import React from "react";
import { Button, useNotify, useRefresh } from "react-admin";
import ConfirmModal from "server/components/Modals/ConfirmModal";
import ThumbUpAltIcon from "@mui/icons-material/ThumbUpAlt";
import dataProvider from "server/dataProvider";
import { graduationRequests } from "api/graduationApi";

const FinalizeInternshipSessionDialog = ({ id, checkIsFinalized }) => {
  const notify = useNotify();
  const refresh = useRefresh();

  const handleSubmit = async () => {
    await dataProvider.customRequest(graduationRequests.finalizeInternshipSession(id), null, "POST");
    checkIsFinalized();
    refresh();
    notify("Успешно финализиране на стажантска сесия", { type: "success" });
  };
  return (
    <ConfirmModal
      onConfirm={handleSubmit}
      titleContent={"Финализиране на стажантска сесия"}
      triggerButton={
        <Button
          label="Финализирай"
          startIcon={<ThumbUpAltIcon />}
          variant="contained"
        />
      }
      message="Сигурни ли сте, че искате да финализирате стажантската сесия?"
    />
  );
};

export default FinalizeInternshipSessionDialog;
